import React from "react";

const InputField = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  type = "text",
  error,
  disabled = false,
}) => {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium mb-2">
        {label}
      </label>
      <input
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete={type === "password" ? "new-password" : "off"}
        aria-describedby={error ? `${id}-error` : undefined}
        className={`w-full p-2 border border-gray-300 rounded-md h-12 focus:outline-none focus:ring-2 transition-all ${
          disabled
            ? "bg-gray-200 cursor-not-allowed"
            : "focus:ring-blue-500"
        } ${error ? "border-red-500" : ""}`}
      />
      {error && (
        <p id={`${id}-error`} className="text-red-500 text-sm mt-1">
          {error}
        </p>
      )}
    </div>
  );
};

export default InputField;